import { ComponentProps, Suspense } from 'react';
import { useImage } from 'react-image';
import { ErrorBoundary } from 'react-error-boundary';

import { Skeleton } from '@/components/common/Skeleton';
import { isEnvironment } from '@/utils';

const ImageComponent = ({ src, alt, ...props }: ComponentProps<'img'>) => {
  const { src: loadedSrc } = useImage({
    srcList: src || '',
  });

  return (
    <img
      onContextMenu={(e) => !isEnvironment('development') && e.preventDefault()}
      draggable={false}
      src={loadedSrc}
      alt={alt}
      {...props}
    />
  );
};

const SuspenseImage = ({ className, ...props }: ComponentProps<'img'>) => {
  return (
    <Suspense fallback={<Skeleton className={className} />}>
      <ErrorBoundary
        FallbackComponent={() => <img className={className} alt={props.alt} {...props} />}
      >
        <ImageComponent className={className} {...props} />
      </ErrorBoundary>
    </Suspense>
  );
};

export default SuspenseImage;
